"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZipCodeUtil = void 0;
class ZipCodeUtil {
    static maskZipCode(zipCode) {
        if (!zipCode)
            return '';
        // Strip all non-numeric characters
        let zip = zipCode.replace(/\D/g, '');
        if ((zipCode.length === 6 && zipCode.endsWith('-')) || (zipCode.length === 7 && isNaN(parseInt(zipCode[zipCode.length - 1])))) {
            // Added a dash or non-numeric character, so keep exactly one dash
            zip = zipCode.substring(0, zipCode.indexOf('-') + 1);
        }
        else if (zip.length > 5) {
            // Zip code is more than 5 characters so we added a number, insert the dash in between and apply the proper formatting
            zip = zip.replace(/^(\d{0,5})(\d{0,4})/, '$1-$2');
            // Ensure only 4 digits after the hyphen
            if (zip.length > 10) {
                zip = zip.substring(0, 10);
            }
        }
        // Remove extra white-space that is inserted by the above replace until there are enough characters
        zip = zip.trim();
        return zip;
    }
    static moveCursorForZipCode(input, cursorPosition, previousCharCount, zip, event) {
        const isDeleteEvent = event.inputType === 'deleteContentBackward' || event.inputType === 'deleteContentForward';
        let newCursorPosition = cursorPosition;
        //First condition deals with if a new non-numeric character was inserted by the above regex and there are not any characters to the right of the cursor.
        //For example (x is the user's cursor, 9 is the entered character) 1510x -> 15108x
        //Second condition deals with If they are not deleting a character and the next character is the dash, move their
        //cursor to before the next number.
        //For example (x is the user's cursor, 9 is the entered character) 15108x- -> 15108-9x
        //Third condition deals with If a new digit is entered after the hyphen, move the cursor to the correct position
        if ((typeof zip === 'string' && previousCharCount < (zip.match(/\D/g) || []).length && zip.substring(newCursorPosition, zip.length) === '') || (!isDeleteEvent && zip[newCursorPosition] === '-') || (!isDeleteEvent && zip.length > 6 && newCursorPosition === 6)) {
            newCursorPosition++;
        }
        input.setSelectionRange(newCursorPosition, newCursorPosition);
    }
    static validateZipCode(zipCode) {
        if (zipCode.length >= 5) {
            return { valid: true, error: '' };
        }
        else {
            return { valid: false, error: 'Please enter a valid five-digit zip code' };
        }
    }
}
exports.ZipCodeUtil = ZipCodeUtil;
